import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client';
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface';
import { ChatFileRoutes } from '@common-frontend-submodule/enums/routes/chat-file-routes.enum';
import { IChatFileDTO } from '@common-frontend-submodule/interfaces/chat-file/ichat-file.interface';
import { IChatFileCreationDTO } from '@common-frontend-submodule/interfaces/chat-file/ichat-file-creation.interface';

const apiClient = ApiClient.getInstance()

interface ChatFileContextProps {
  getById: (chatFileId: string) => Promise<IApiResponseGenericDTO<IChatFileDTO>>;
  getAll: (chatId: string) => Promise<IApiResponseGenericDTO<IChatFileDTO[]>>;
  getAllClientFiles: (clientId: string) => Promise<IApiResponseGenericDTO<IChatFileDTO[]>>;
  uploadFile: (file: File, model: IChatFileCreationDTO) => Promise<IApiResponseGenericDTO<IChatFileDTO[]>>;
}

const ChatFileContext = createContext<ChatFileContextProps | undefined>(undefined);

export const ChatFileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (chatFileId: string): Promise<IApiResponseGenericDTO<IChatFileDTO>> => {
    return await apiClient.getRequest<IChatFileDTO>(`${ChatFileRoutes.BasePrefix}/${chatFileId}`);
  };

  const getAll = async (chatId: string): Promise<IApiResponseGenericDTO<IChatFileDTO[]>> => {
    return await apiClient.getRequest<IChatFileDTO[]>(`${ChatFileRoutes.BasePrefix}/all/${chatId}`);
  };
  const getAllClientFiles = async (clientId: string): Promise<IApiResponseGenericDTO<IChatFileDTO[]>> => {
    return await apiClient.getRequest<IChatFileDTO[]>(`${ChatFileRoutes.BasePrefix}/all-files/${clientId}`);
  };
  const uploadFile = async (file: File, model: IChatFileCreationDTO): Promise<IApiResponseGenericDTO<IChatFileDTO[]>> => {
    const formData = new FormData();

    formData.append('file', file);

    Object.entries(model).forEach(([key, value]) => {
      formData.append(key, value as string); // Преобразуем значение в строку
    });

    return await apiClient.postFormDataRequest<FormData, IChatFileDTO[]>(
      ChatFileRoutes.BasePrefix,
      formData,
    );
  };

  return (
    <ChatFileContext.Provider value={{ getAllClientFiles, getById, getAll, uploadFile }}>
      {children}
    </ChatFileContext.Provider>
  );
};

export const useChatFileStore = () => {
  const context = useContext(ChatFileContext);
  if (!context) {
    throw new Error('useChatFileStore must be used within a useChatFileStore');
  }
  return context;
};
